import { Language, TemplateSubType, TemplateType } from '../../../types/dto-app';

export const leaseUnpaidAmountReminderTemplates = [
  {
    id: '-227001',
    language: Language.EN,
    subject: 'Reminder 1: Unpaid amount',
    type: TemplateType.SMS,
    subType: TemplateSubType.LEASE_UNPAID_AMOUNT_REMINDER,
    clientId: 'Template#-1',
    readId: 'R#Template#-1',
    body: `
          <p>Dear tenant,</p>
          {{#if isPartiallyPaid}}
          <p>A remaining balance of {{totalAmount}} € is still unpaid (original amount: {{amountTotal}} €, already paid: {{amountPaid}} €).</p>
          {{else}}
          <p>An amount of {{totalAmount}} € remains unpaid.</p>
          {{/if}}
          <p>More details here: {{pdfLink}}.</p>
          <p>Kind regards.</p>
      `,
  },
  {
    id: '-227002',
    language: Language.FR,
    subject: 'Rappel 1: Montant impayé',
    type: TemplateType.SMS,
    subType: TemplateSubType.LEASE_UNPAID_AMOUNT_REMINDER,
    clientId: 'Template#-1',
    readId: 'R#Template#-1',
    body: `
          <p>Cher/Chère locataire,</p>
          {{#if isPartiallyPaid}}
          <p>Un solde restant de {{totalAmount}} € demeure impayé (montant initial : {{amountTotal}} €, déjà payé : {{amountPaid}} €).</p>
          {{else}}
          <p>Le montant de {{totalAmount}} € demeure impayé.</p>
          {{/if}}
          <p>Plus de détails ici : {{pdfLink}}.</p>
          <p>Bien à vous.</p>
      `,
  },
  {
    id: '-227003',
    language: Language.NL,
    subject: 'Herinnering 1: Onbetaald bedrag',
    type: TemplateType.SMS,
    subType: TemplateSubType.LEASE_UNPAID_AMOUNT_REMINDER,
    clientId: 'Template#-1',
    readId: 'R#Template#-1',
    body: `
        <p>Beste huurder,</p>
        {{#if isPartiallyPaid}}
        <p>Een resterend saldo van {{totalAmount}} € blijft onbetaald (oorspronkelijk bedrag: {{amountTotal}} €, reeds betaald: {{amountPaid}} €).</p>
        {{else}}
        <p>Een bedrag van {{totalAmount}} € blijft onbetaald.</p>
        {{/if}}
        <p>Meer details hier: {{pdfLink}}.</p>
        <p>Groeten.</p>
      `,
  },
  {
    id: '-227004',
    language: Language.DE,
    subject: 'Erinnerung 1: Unbezahlter Betrag',
    type: TemplateType.SMS,
    subType: TemplateSubType.LEASE_UNPAID_AMOUNT_REMINDER,
    clientId: 'Template#-1',
    readId: 'R#Template#-1',
    body: `
        <p>Liebe/r Mieter/in,</p>
        {{#if isPartiallyPaid}}
        <p>Ein verbleibender Restbetrag von {{totalAmount}} € ist noch unbezahlt (Ursprungsbetrag: {{amountTotal}} €, bereits bezahlt: {{amountPaid}} €).</p>
        {{else}}
        <p>Ein Betrag von {{totalAmount}} € ist noch unbezahlt.</p>
        {{/if}}
        <p>Weitere Details hier: {{pdfLink}}.</p>
        <p>Mit freundlichen Grüßen.</p>
      `,
  },
];
